const trackTabClick = (tabName: string) => {
  const eventMapping: Record<string, string> = {
    'tab-description': 'description_clicked',
    'tab-reviews': 'reviews_clicked',
    'tab-yarn-patterns': 'patterns_clicked',
    'tab-user-gallery': 'photo_gallery_clicked',
    'tab-qa': 'q_and_a_clicked'
  };

  const eventName = eventMapping[tabName];

  if (eventName && window.posthog) {
    window.posthog.capture(eventName);
  }
};

export { trackTabClick };
